<template>
  <div class="container-bg relative bg-gradient-to-b from-[#191822]/50 to-[#191822]">
    <div class="absolute inset-0 w-full h-full bg-center bg-[#080809]/50"></div>
    <img src="@/assets/overlay-5.avif"
      class="absolute top-[45px] -left-28 block object-cover object-center w-auto h-full max-w-[200px] lg:max-w-[600px] 2xl:max-w-[811px]"
      alt="overlay 1" />
    <img src="@/assets/overlay-6.avif"
      class="absolute top-[45px] -right-28 block object-cover object-center w-auto h-full max-w-[200px] lg:max-w-[600px] 2xl:max-w-[811px]"
      alt="overlay 2" />
    <img src="@/assets/planet-3.avif"
      class="absolute top-[156px] left-0  block object-contain w-auto h-[94px] md:h-[552px]"
      alt="planet 1" />
    <section
      id="promotions"
      class="relative overflow-hidden z-10 h-full py-10 pb-20"
    >
      <div class="relative mx-auto">
        <!-- Promotions Title -->
        <h1 class="text-2xl md:text-[32px] md:leading-10 tracking-wide font-bold font-orbitron text-white uppercase md:text-3xl text-center text-shadow">
          PROMOTIONS
        </h1>

        <!-- Promo Card -->
        <div class="relative x-5 flex flex-wrap items-start justify-center mx-auto w-full gap-8 mt-10 bg-[#191822] shadow-[-8px_4px_30px_2px_#5C3EB7] rounded-[20px] max-w-[calc(100vw-24px)] h-[640px] lg:max-w-[900px] 2xl:max-w-[1074px] lg:h-[511px] ">

          <img src="@/assets/promo-box.avif"
            class="absolute inset-0 z-10 hidden object-cover object-center w-full h-full rounded-[20px] bg-repeat-y lg:block xl:max-h-full xl:object-cover xl:object-top"
            alt="background-image" />
          <img src="@/assets/promo-box-sp.avif"
            class="absolute inset-0 z-10 lg:hidden object-cover object-center w-full h-full rounded-[20px] bg-repeat-y xl:block xl:max-h-full xl:object-cover xl:object-top"
            alt="background-image" />
          <img src="@/assets/moonlight-logo2.png"
            class="absolute -top-16 -left-10 lg:-bottom-32 lg:hidden lg:-right-[85px] lg:left-[unset] lg:top-[unset] z-[11] h-[115px] lg:h-[192px] w-auto object-contain"
            alt="moonlight logo" />
          <img src="@/assets/moonlight-logo3.avif"
            class="absolute -bottom-20 hidden lg:block -right-20 z-[11] h-[115px] lg:h-[192px] w-auto object-contain"
            alt="moonlight logo" />
          <div
            v-motion-pop-visible
            class="relative z-20 flex flex-col justify-end lg:items-end w-full rounded-[10px] pb-10 lg:pt-0 overflow-hidden text-center"
          >
            <!-- Content -->
            <div
              class="relative z-10 px-14 pt-8 lg:pl-10 xl:px-6 gap-[30px] xl:gap-12 flex flex-col justify-center lg:justify-end h-full pb-10 lg:pb-20 xl:pb-14 2xl:pb-12"
            >
              <!-- Logo -->
              <img src="../assets/goated-logo.png" class="h-[35px] w-auto object-contain z-20 lg:h-20 xl:h-[85px] 2xl:h-[100px]" alt="hero text">
              <!-- Promo Details -->
              <div
                class="flex flex-col items-end gap-y-4"
              >
                <h1 class="text-base lg:text-lg text-white font-normal font-inter text-center lg:text-right">
                  REGISTER NOW TO GET EXCITING REWARDS<br class="hidden lg:block"> EVERYDAY!
                </h1>
                <h1 class="text-base lg:text-lg text-white font-normal font-inter text-center lg:text-right">
                  RECEIVE 100% COMMISSIONS ON YOUR GAMEPLAY <br class="hidden lg:block">WEEKLY TIP OUTS AND EXCLUSIVE GIVEAWAYS
                </h1>
                <!-- <h1 class="text-lg font-normal text-white font-inter lg:text-2xl">
                  EVERYDAY!
                </h1> -->
              </div>
              <div class="w-fit font-orbitron relative border-[2px] border-white rounded-2xl bg-gradient-to-r from-[#5C3EB7] to-[#2D1C63]
                overflow-hidden flex items-center self-center lg:self-end shadow-[-14px_10px_44px_-20px_#FFFFFF]">
                <a href="https://kick.com/moonlight2019" class="z-10 px-[30px] py-[18px] md:text-lg lg:text-2xl !leading-6 font-bold text-white hero-button-text
                text-center whitespace-nowrap">
                  Watch live on Kick.com
                </a>
                <img src="@/assets/hero-btn-style-1.png" alt="Decorative slant shadow"
                  class="absolute inset-y-0 left-0 h-full pointer-events-none" />
                <img src="@/assets/hero-btn-style-2.png" alt="Decorative slant shadow"
                  class="absolute inset-y-0 right-0 h-full pointer-events-none" />
              </div>
            </div>
          </div>
        </div>
        <div class="relative h-[389px] md:h-[501px] mt-10 md:mt-[167px] w-full flex flex-col justify-center items-center gap-6 font-orbitron px-5">
          <img src="@/assets/promo-card.avif" alt="promo card" class="absolute inset-0 object-cover object-center h-[501px] w-full hidden md:block">
          <img src="@/assets/promo-card-sp.avif" alt="promo card" class="absolute inset-0 object-cover object-center h-[389px] w-full block md:hidden">
          <h1 class="font-bold text-2xl md:text-5xl text-white text-center">
            VIP Transfer to Goated.com
          </h1>
          <p class="md:text-2xl font-normal text-white text-center">
            Get a cash bonus of up to
          </p>
          <h4 class="text-2xl md:text-5xl font-bold text-white">
            $11,250
          </h4>
          <div class="relative border-[2px] border-white rounded-2xl bg-[#191822]
              overflow-hidden flex items-center justify-center shadow-[-14px_10px_44px_-20px_#FFFFFF] hero-button-text hover:scale-105">
              <a href="https://help.goated.com/en/articles/9671083-vip-transfer" class="z-10 px-[30px] py-4 text-lg sm:text-xl md:text-2xl leading-6 font-bold text-white hero-button-text
              text-center whitespace-nowrap">
                Discover more
              </a>
              <img src="@/assets/hero-btn-style-1.png" alt="Decorative slant shadow"
                class="absolute inset-y-0 left-0 h-full pointer-events-none" />
              <img src="@/assets/hero-btn-style-2.png" alt="Decorative slant shadow"
                class="absolute inset-y-0 right-0 h-full pointer-events-none" />
            </div>
        </div>
      </div>
    </section>
     <CommissionCalculator class="mb-20" />
    <SocialSection />
  </div>
</template>

<script>
import { ref } from "vue";
import SocialSection from "@/sections/SocialSection.vue";
import CommissionCalculator from "@/components/CommissionCalculator.vue";

export default {
  components: {
    SocialSection,
    CommissionCalculator
  },
  data() {
    return {
      hoveredButton1: ref(false),
    };
  },
};
</script>
<style>
  .text-shadow {
    text-shadow: -3px  4px 4px #5C3EB7;
  }
</style>
